/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { CircularProgress, Modal, styled } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  CustomLabel,
  CustomSwitch,
} from 'components/Common/MUIStyledComponents';
import NotificationsModal from 'components/Monitor/Modals/NotificationModal';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import MarkunreadOutlinedIcon from '@mui/icons-material/MarkunreadOutlined';
import { enqueueSnackbar } from 'notistack';
import BiteDBAPI from 'api/BiteDBAPI';
import EntriesRow from 'components/Monitor/ResultsTab/TableFilters/EntriesRow';

interface IScreen {
  databases?: any;
  isLoading?: boolean;
}

const CustomSelect = styled(Select)({
  '.MuiSelect-icon': {
    color: 'var(--card-text)',
  },
  'overflow': 'hidden',
  'color': 'var(--Text-Main, var(--text-primary))',
  'textOverflow': 'ellipsis',
  'fontFamily': 'Inter',
  'fontSize': '16px',
  'fontStyle': 'normal',
  'fontWeight': 400,
  'lineHeight': '24px',
  'borderRadius': '8px',
  'border': '1px solid var(--bg-secondary)g-secondary)',
});

const SchedulePeriodicComp: React.FC<IScreen> = ({ databases, isLoading }) => {
  const [ frequency, setFrequency ] = useState<string>('Weekly');
  const [ weekDay, setWeekDay ] = useState<string>('Monday');
  const [ riskThreshold, setRiskThreshold ] = useState<string>('Medium');
  const [ isNotification, setIsNotification ] = useState(false);
  const [ isNotificationOpen, setIsNotificationOpen ] = useState(false);
  const [ isAdvancedSetting, setIsAdvancedSetting ] = useState(false);
  const [ selectedOpts, setSelectedOpts ] = useState([]);
  const [ selectedOptsType, setSelectedOptsType ] = useState([]);
  const [ selectedRows, setSelectedRows ] = useState<any[]>([]);
  const [ savingDatabases, setSavingDatabases ] = React.useState(false);

  useEffect(() => {
    if (selectedOptsType.length > 0) {
      setIsNotification(true);
    } else {
      setIsNotification(false);
    }
  }, [ selectedOptsType ]);

  const handleWeekDayChange = (
    event: React.ChangeEvent<{ value: unknown }>,
  ) => {
    setWeekDay(event.target.value as string);
  };

  const handleFrequencyChange = (
    event: React.ChangeEvent<{ value: unknown }>,
  ) => {
    setFrequency(event.target.value as string);
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (selectedOptsType.length > 0) {
      setIsNotificationOpen(true);
    } else {
      // setIsNotification(!isNotification);
      setIsNotificationOpen(!isNotificationOpen);
    }
  };

  const handleSaveSettings = async() => {
    try {
      const ids = selectedRows.map((db) => db.id);
      setSavingDatabases(true);
      const settingsData = {
        last_updated: '',
        screening_frequency: frequency,
        screening_day_of_week: weekDay,
        notifications_email: `${selectedOptsType}`,
        notifications_enabled: isNotification,
        ids: ids,
      };

      if (!settingsData.ids) {
        enqueueSnackbar('Please select at least one database', {
          variant: 'error',
        });
        return;
      }

      const response = await BiteDBAPI.updateDatabases(settingsData);
      if (response?.success) {
        setSavingDatabases(false);
        enqueueSnackbar('Your schedule setting has been updated successfully', {
          variant: 'success',
        });
        setFrequency('Once');
        setWeekDay('Sunday');
        setSelectedOptsType([]);
        setSelectedRows([]);
        setIsNotification(false);
      } else {
        setSavingDatabases(false);
        enqueueSnackbar(
          `Error updating schedule settings: ${response?.result}`,
          {
            variant: 'error',
          },
        );
      }
    } catch (e) {
      setSavingDatabases(false);
    }
  };

  return (
    <>
      <div className='screening-settings'>
        <div className='screening-settings-col' style={{ gap: '0px' }}>
          <h2>
            <SettingsOutlinedIcon
              sx={{ fontSize: 20, color: 'var(--Primary-400, #4895ef)' }}
            />{' '}
            Screening Settings
          </h2>
          <p className='subtitle'>
            Configure automated screening for Global Suppliers
          </p>
        </div>

        <div className='screening-settings-col'>
          <div className='hit-title'>
            <AccessTimeOutlinedIcon sx={{ fontSize: 14 }} /> Screening Frequency
          </div>
          <div className='screening-settings-row'>
            <div
              className='audit-add-modal-cont-body-frame-form'
              style={{ width: '100%' }}
            >
              <div className='audit-add-modal-cont-body-frame-form-row'>
                <div className='audit-add-modal-cont-body-frame-form-row-input'>
                  <div className='audit-add-modal-cont-body-frame-form-row-input-label'>
                    <div className='audit-add-modal-cont-body-frame-form-row-input-label-text'>
                      Frequency
                    </div>
                    <FormControl sx={{ width: '100%', height: '48px' }}>
                      <CustomSelect
                        value={frequency}
                        onChange={handleFrequencyChange}
                        fullWidth
                        IconComponent={KeyboardArrowDownIcon}
                        inputProps={{
                          MenuProps: {
                            MenuListProps: {
                              sx: {
                                backgroundColor: 'var(--bg-colors)',
                                color: 'var(--Text-Main, var(--text-primary))',
                              },
                            },
                          },
                        }}
                      >
                        <MenuItem value={'Once'}>Once</MenuItem>
                        <MenuItem value={'Daily'}>Daily</MenuItem>
                        <MenuItem value={'Weekly'}>Weekly</MenuItem>
                        <MenuItem value={'Monthly'}>Monthly</MenuItem>
                        <MenuItem value={'Yearly'}>Yearly</MenuItem>
                      </CustomSelect>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
            {
              frequency === 'Weekly' && (
                <div
                  className='audit-add-modal-cont-body-frame-form'
                  style={{ width: '100%' }}
                >
                  <div className='audit-add-modal-cont-body-frame-form-row'>
                    <div className='audit-add-modal-cont-body-frame-form-row-input'>
                      <div className='audit-add-modal-cont-body-frame-form-row-input-label'>
                        <div className='audit-add-modal-cont-body-frame-form-row-input-label-text'>
                      Day of Week
                        </div>
                        <FormControl sx={{ width: '100%', height: '48px' }}>
                          <CustomSelect
                            value={weekDay}
                            onChange={handleWeekDayChange}
                            fullWidth
                            IconComponent={KeyboardArrowDownIcon}
                            inputProps={{
                              MenuProps: {
                                MenuListProps: {
                                  sx: {
                                    backgroundColor: 'var(--bg-colors)',
                                    color: 'var(--Text-Main, var(--text-primary))',
                                  },
                                },
                              },
                            }}
                          >
                            <MenuItem value={'Monday'}>Monday</MenuItem>
                            <MenuItem value={'Tuesday'}>Tuesday</MenuItem>
                            <MenuItem value={'Wednesday'}>Wednesday</MenuItem>
                            <MenuItem value={'Thursday'}>Thursday</MenuItem>
                            <MenuItem value={'Friday'}>Friday</MenuItem>
                            <MenuItem value={'Saturday'}>Saturday</MenuItem>
                            <MenuItem value={'Sunday'}>Sunday</MenuItem>
                          </CustomSelect>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }

          </div>
        </div>

        <div className='screening-divider'></div>

        <div className='screening-settings-col'>
          <div className='hit-main'>
            <div className='hit-title'>Databases to Screen</div>
            <div className='hit-meta'>
              Select which databases to include in the scheduled screening
            </div>
          </div>
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <CircularProgress color='primary' />
            </div>
          ) : databases?.length === 0 ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <p style={{ color: 'var(--Primary-400, #4895ef)' }}>
                No databases found
              </p>
            </div>
          ) : (
            <div className='screening-periodic-grid'>
              {databases?.map((row: any, index: number) => (
                <EntriesRow
                  key={index}
                  name={row.name}
                  row={row}
                  selectedItems={selectedOpts}
                  setSelectedItems={setSelectedOpts}
                  setSelectedRows={setSelectedRows}
                />
              ))}
            </div>
          )}
        </div>

        <div className='screening-divider'></div>

        <div className='screening-settings-col'>
          <div className='hit-main'>
            <div className='hit-title'>
              <MarkunreadOutlinedIcon sx={{ fontSize: 14 }} /> Email
              Notifications
            </div>
          </div>
          <div className='screening-settings-row'>
            <div className='hit-main'>
              <div className='hit-title'>
                <strong>Send Email Notifications / In-App Notification</strong>
              </div>
              <div className='hit-meta'>
                Get notified when screening results are available
              </div>
            </div>
            <CustomLabel
              control={
                <CustomSwitch
                  checked={isNotification}
                  onChange={handleSwitchChange}
                  name='work'
                />
              }
            />
          </div>
        </div>

        <div className='team-content-header'>
          <div
            className='create-new-team-btn'
            style={{
              width: '100%',
              margin: '0px',
              border: '1px solid var(--Primary-400, #4895ef)',
              background: 'var(--Primary-400, #4895ef)',
            }}
            onClick={handleSaveSettings}
          >
            <div
              className='create-new-team-btn-text'
              style={{ display: 'flex', color: 'var(--text-primary)' }}
            >
              {savingDatabases && (
                <CircularProgress
                  style={{ width: '20px', height: '20px', marginRight: '10px' }}
                  color='primary'
                />
              )}{' '}
              Schedule Screening
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={isNotificationOpen}
        onClose={() => setIsNotificationOpen(false)}
      >
        <NotificationsModal
          selectedOptsType={selectedOptsType}
          setSelectedOptsType={setSelectedOptsType}
          handleClose={() => setIsNotificationOpen(false)}
          handleSave={() => setIsNotificationOpen(false)}
        />
      </Modal>
    </>
  );
};

export default SchedulePeriodicComp;
